import React, { useEffect, useState } from 'react';
import { FiSearch, FiEye } from 'react-icons/fi';
import { adminApi } from '../../services/adminApi';

function AdminRiskScores() {
  const [farms, setFarms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedRating, setSelectedRating] = useState('all');
  const [search, setSearch] = useState('');
  const [searchDebounced, setSearchDebounced] = useState('');

  useEffect(() => {
    const t = setTimeout(() => setSearchDebounced(search), 300);
    return () => clearTimeout(t);
  }, [search]);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (selectedRating !== 'all') params.rating = selectedRating;
    if (searchDebounced) params.search = searchDebounced;
    adminApi.getRiskScores(params)
      .then((res) => {
        if (res.success) {
          setFarms(res.data || []);
          setError(null);
        } else setError(res.message || 'Failed to load');
      })
      .catch((err) => {
        setError(err.message || 'Failed to load');
        setFarms([]);
      })
      .finally(() => setLoading(false));
  }, [selectedRating, searchDebounced]);

  const ratingColors = { A: 'risk-a', B: 'risk-b', C: 'risk-c', D: 'risk-d', E: 'risk-e' };

  return (
    <div className="admin-page">
      <div className="admin-page-header admin-page-header-row">
        <div>
          <h1>Risk Review Panel</h1>
          <p>Review AI-generated risk scores and classifications</p>
        </div>
      </div>
      <div className="admin-toolbar">
        <div className="admin-search">
          <FiSearch className="admin-search-icon" />
          <input
            type="search"
            placeholder="Search farms..."
            className="admin-search-input"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="admin-filter-tabs">
          {['all', 'A', 'B', 'C', 'D', 'E'].map((r) => (
            <button
              key={r}
              className={`admin-filter-tab admin-risk-tab ${selectedRating === r ? 'active' : ''} ${r !== 'all' ? ratingColors[r] : ''}`}
              onClick={() => setSelectedRating(r)}
            >
              {r === 'all' ? 'All' : `Rating ${r}`}
            </button>
          ))}
        </div>
      </div>
      <div className="admin-table-card">
        {loading ? (
          <div className="admin-loading" />
        ) : error ? (
          <p className="admin-error">{error}</p>
        ) : farms.length === 0 ? (
          <p className="admin-empty">No risk scores found</p>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Farm ID</th>
                <th>Farmer</th>
                <th>Crop / Livestock</th>
                <th>Location</th>
                <th>Rating</th>
                <th>Score</th>
                <th>Default Prob.</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {farms.map((f) => (
                <tr key={f.id}>
                  <td><code>F{String(f.id).padStart(3, '0')}</code></td>
                  <td>{f.farmer}</td>
                  <td>{f.crop || '-'}</td>
                  <td>{f.location || '-'}</td>
                  <td>
                    {f.rating ? (
                      <span className={`admin-risk-badge ${ratingColors[f.rating]}`}>
                        {f.rating}
                      </span>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>{f.score ?? '-'}</td>
                  <td>{f.default_probability || '-'}</td>
                  <td>
                    <button className="admin-btn-icon" title="View details">
                      <FiEye />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default AdminRiskScores;
